import React from 'react'
import PageHeader from '../components/PageHeader'

function RUSA() {
  return (
    <div>
      <PageHeader title="RUSA" />
    </div>
  )
}

export default RUSA
